import React from "react"

export const FilterSliders = ({ height = 24, width = 24, fill = "#525455", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <line x1="4" y1="6" x2="20" y2="6" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
    <line x1="4" y1="12" x2="20" y2="12" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
    <line x1="4" y1="18" x2="20" y2="18" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="8" cy="6" r="2" fill="white" stroke={fill} strokeWidth="1.5" />
    <circle cx="16" cy="12" r="2" fill="white" stroke={fill} strokeWidth="1.5" />
    <circle cx="10" cy="18" r="2" fill="white" stroke={fill} strokeWidth="1.5" />
  </svg>
)
